import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";

import { useQuery } from "react-query";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";
import { Panel } from "../../shared/interfaces/Switchgear";

export function usePanelsBySwitchgear(switchgearAssetId?: number, callbacks?: QueryCallbacks<Panel[]>) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: [`panelsBySwitchgear-${switchgearAssetId}`],
    queryFn: async () => {
      if (switchgearAssetId) {
        return await apiContext.assetApis.getPanelsBySwitchgear(switchgearAssetId);
      }
    },
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
    refetchOnWindowFocus: false,
  });
}
